export const environment = {
  production: true,
  BASE_API_URL: 'https://dclean.wdprapps.disney.com/',
  BASE_IMG_URL: 'https://s3.amazonaws.com/wdw-cast-cot-files-prod'
};



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/environments/environment.ts